import { useSearchParams } from 'react-router-dom'

import { SortByShape } from '../../../hooks/use-sort-data'
import { SortDirection } from '../../../types'
import { ChainTable, ChainTableColumn } from '../components/ChainTable'
import { DateFilter } from '../components/DateFilter'
import { StickyShadow } from '../components/StickyShadow'
import { StrikeFilter } from '../components/StrikeFilter'
import ViewFooter from '../components/ViewFooter'
import { columnMap } from '../constants/columns'
import { useOptionsQuery } from '../hooks/useOptionsQuery'
import { useOptionsSortChange } from '../hooks/useOptionsSortChange'
import { useOptionsSortOrder } from '../hooks/useOptionsSortOrder'
import { ColumnId, OptionsByDateLoader, OptionsByStrikeLoader, OptionsView } from '../types'
import { evalLinkOrder } from '../utils/query'

export function ChainRoute({ options, lastClose, lastTime, ...props }: OptionsByDateLoader | OptionsByStrikeLoader) {
  const middleColumn = props.view === OptionsView.ChainByDate ? ColumnId.StrikePrice : ColumnId.ExpirationDate
  const filterColumn = props.view === OptionsView.ChainByDate ? ColumnId.ExpirationDate : ColumnId.StrikePrice
  const [searchParams] = useSearchParams()
  const query = useOptionsQuery(searchParams)
  const tableOrder = useOptionsSortOrder(props.subpage, query, middleColumn)
  const effectiveTableOrder = evalLinkOrder(tableOrder, middleColumn)
  const optionsSortChange = useOptionsSortChange(props.subpage, query)

  const handleSortChange = (
    column: ChainTableColumn,
    sort: SortByShape<ChainTableColumn>,
    changeSort: (newSort: any, direction?: SortDirection) => void
  ) => optionsSortChange(column, sort, changeSort, '', column.id === middleColumn)

  return (
    <>
      <div>
        <div className="sticky z-30 bg-primary py-2 sticky-22">
          <div className="fv-container flex items-center">
            <div className="flex w-full items-center justify-between">
              <h2 className="my-0 text-base text-muted font-bold">Calls</h2>
              <div className="flex-1 pr-1 text-right text-2xs text-muted-2">{columnMap[filterColumn].name}</div>
            </div>
            <div className="w-28 shrink-0">
              {props.view === OptionsView.ChainByDate && (
                <DateFilter currentExpiry={props.currentExpiry} expiries={props.expiries} />
              )}
              {props.view === OptionsView.ChainByStrike && (
                <StrikeFilter currentStrike={props.currentStrike} strikes={props.strikes} />
              )}
            </div>
            <div className="w-full">
              <h2 className="my-0 text-right text-base text-muted font-bold">Puts</h2>
            </div>
          </div>
        </div>

        <StickyShadow className="z-10 h-5.5 bg-primary sticky-33" />
        <div className="fv-container">
          <ChainTable
            key={props.view}
            isHeaderSticky
            className="-mt-5.5"
            headerClass="sticky-33"
            data={options}
            lastClose={lastClose}
            lastTime={lastTime}
            middleColumn={middleColumn}
            subpage={props.subpage}
            tableOrder={effectiveTableOrder}
            onSortChange={(column, sort, changeSort) => handleSortChange(column, sort, changeSort)}
          />
        </div>
      </div>
      <ViewFooter className="fv-container pb-4" />
    </>
  )
}
